export default [
  function() {
    window.location.reload()
  }
]



// WEBPACK FOOTER //
// ./src/modules/App/chains/reload.js